(function() {
	'use strict';

	angular.module('widgets.initiative')
	.service('leanProjectMonthlySavingsService', leanProjectMonthlySavingsService);

	function leanProjectMonthlySavingsService($http, URLS) {
		return {
			getLeanProjectMonthlySavings: getLeanProjectMonthlySavings
		};

		function getLeanProjectMonthlySavings(filterService, savingsType) {
			if (!savingsType) {
				savingsType = 'totalSavings';
			}
			var factories = filterService.getFactoryList();
			var url = URLS.host + URLS.prefix + factories + '/LeanProjectMonthlySavings';
			url += '?savingsType=' + savingsType;
			url = filterService.addFilterQueryParams(url);
			
			return $http.get(url)
				.then(getProjectsTargetVsActualComplete)
				.catch(getProjectsTargetVsActualFailed);

			function getProjectsTargetVsActualComplete(response) {
				return response.data;
			}
			function getProjectsTargetVsActualFailed(error) {
				return error;
			}
		}
	}
})();